export enum PlanNickName {
  Daily = 'daily',
  Monthly = 'monthly',
  Yearly = 'yearly',
  Month = 'month',
  Year = 'year'
}
